import { FaFolder, FaExternalLinkAlt, FaGlobe, FaCode } from "react-icons/fa";

const categories = [
  {
    id: "netsuite",
    label: "Proyectos NetSuite",
    icon: <FaCode />,
    projects: [
      {
        title: "Cancelación de Saldos",
        desc: "Libera los saldos pendientes de tus clientes de forma ágil y segura a través de una cuenta puente, simplificando el proceso de conciliación contable.",
        tags: ["SuiteScript 2.1", "REST API", "HTML5"],
        github: "#",
        live: "#",
      },
      {
        title: "Integraciones API REST y FTP",
        desc: "NetSuite permite conexiones personalizadas con sistemas externos como POS, sistemas de trazabilidad de rutas y envío de archivos bancarios, adaptadas a las necesidades específicas de cada empresa.",
        tags: ["SuiteScript 2.1", "REST API", "FTP"],
        github: "#",
        live: "#",
      },
      {
        title: "Cancelación CFDI, Adendas y Pedimentos",
        desc: "Gestión fiscal completa: cancelación de CFDI, complementos de adendas y trazabilidad de pedimentos, implementados con precisión, seguridad y apego a la normativa vigente.",
        tags: ["SuiteScript 2.1", "XML", "SAT"],
        github: "#",
        live: "#",
      },
    ],
  },
  {
    id: "web",
    label: "Proyectos WEB",
    icon: <FaGlobe />,
    projects: [
      {
        title: "Control Presupuestal",
        desc: "Distribuye tus gastos de forma estratégica organizando y planificando los pagos mensuales, con visibilidad clara para establecer metas financieras a corto y largo plazo.",
        tags: ["JavaScript", "Node.js", "DB"],
        github: "#",
        live: "#",
      },
      {
        title: "Gestión de Proyectos",
        desc: "Organiza a tu equipo de manera técnica y eficiente asignando actividades sin comprometer la carga laboral. Al cierre de cada mes, consulta los KPIs individuales de cada colaborador para una toma de decisiones informada.",
        tags: ["JavaScript", "Node.js", "DB"],
        github: "#",
        live: "#",
      },
      {
        title: "MiniERP",
        desc: "Solución integral que incluye autenticación con control de usuarios y roles, punto de venta (POS), gestión de inventario, cuentas por pagar (CXP) y cuentas por cobrar (CXC).",
        tags: ["JavaScript", "Node.js", "DB"],
        github: "#",
        live: "#",
      },
    ],
  },
];

function openComingSoon(title, desc) {
  const win = window.open("", "_blank");
  win.document.write(`<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>${title}</title>
  <style>
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body {
      background: #0d1117;
      color: #c9d1d9;
      font-family: 'Segoe UI', sans-serif;
      display: flex;
      align-items: center;
      justify-content: center;
      min-height: 100vh;
      padding: 2rem;
    }
    .card {
      background: #161b22;
      border: 1px solid #30363d;
      border-radius: 12px;
      max-width: 560px;
      width: 100%;
      padding: 3rem 2.5rem;
      text-align: center;
    }
    .badge {
      display: inline-block;
      background: rgba(88,166,255,0.1);
      color: #58a6ff;
      border: 1px solid #58a6ff;
      border-radius: 999px;
      font-size: 0.75rem;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      padding: 0.3rem 1rem;
      margin-bottom: 1.5rem;
    }
    h1 { font-size: 1.75rem; color: #e6edf3; margin-bottom: 1rem; }
    p  { font-size: 1rem; line-height: 1.7; color: #8b949e; }
  </style>
</head>
<body>
  <div class="card">
    <span class="badge">Próximamente</span>
    <h1>${title}</h1>
    <p>${desc}</p>
  </div>
</body>
</html>`);
  win.document.close();
}

function ProjectCard({ title, desc, tags }) {
  return (
    <div className="pf-project-card">
      <div className="pf-project-card__header">
        <FaFolder className="pf-project-card__icon" />
        <div className="pf-project-card__links">
          <button
            onClick={() => openComingSoon(title, desc)}
            className="pf-project-card__link"
            title="Ver sitio"
            style={{ background: "none", border: "none", cursor: "pointer", padding: 0 }}
          >
            <FaExternalLinkAlt size={16} />
          </button>
        </div>
      </div>
      <p className="pf-project-card__title">{title}</p>
      <p className="pf-project-card__desc">{desc}</p>
      <div className="pf-project-card__tags">
        {tags.map((tag) => (
          <span key={tag} className="pf-project-card__tag">{tag}</span>
        ))}
      </div>
    </div>
  );
}

export default function MyWorks() {
  return (
    <section id="proyectos" className="pf-section" style={{ backgroundColor: "var(--surface)" }}>
      <div className="container">
        <p className="pf-section__label">Portafolio</p>
        <h2 className="pf-section__title">Mis Proyectos</h2>
        <div className="pf-section__divider" />

        {categories.map(({ id, label, icon, projects }) => (
          <div key={id} className="mb-5">
            <h4 className="pf-projects__category-title">
              <span className="pf-projects__category-icon">{icon}</span>
              {label}
            </h4>
            <div className="pf-projects__grid">
              {projects.map((project) => (
                <ProjectCard key={project.title} {...project} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
